import React from "react";
import { useEffect } from "react";
import { faCaretUp } from "@fortawesome/free-solid-svg-icons";
import GeneralButton from "../GeneralButton/GeneralButton";


const activationButton = () => {

  const pageDiv = document.getElementById("page");

  const toTheTopButton = document.querySelector(".tothetop-button");

  if(pageDiv.scrollTop > 300){
    toTheTopButton.style.display = "block"
  }else{
    toTheTopButton.style.display = "none"
  }

}

const ToTheTopButton = () => {
    
  const toTheTop = () => {
    const pageDiv = document.getElementById("page");

    pageDiv.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }

  useEffect(() => {

    const pageDiv = document.getElementById("page");
    
    pageDiv.addEventListener("scroll", activationButton);

    return () => { pageDiv.removeEventListener("scroll", activationButton);}

  }, []);

    
  return (
    <GeneralButton className="tothetop-button" iconClassName="floatTothetop" buttonIcon={faCaretUp} clickFunction={toTheTop}></GeneralButton>
  );
};

export default ToTheTopButton;